import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import api from '../../../api';
import DataTable from './DataTable';
import RefreshTimer from './RefreshTimer';
import DetailModal, { historyDetail } from './DetailModal';

const columns = [
    { key: 'EmployeeName', label: 'Employee Name' },
    { key: 'DirectInspection', label: 'Direct Inspection' },
    { key: 'IndirectInspection', label: 'Indirect Inspection' },
    { key: 'Description', label: 'Description' },
    { key: 'JobNum', label: 'Job #', cellStyle: { fontWeight: 700, fontFamily: '"Courier New", monospace' } },
    { key: 'PartNum', label: 'Part #' },
    { key: 'JobQty', label: 'Job Qty' },
    { key: 'StartTime', label: 'Start Time' },
];

const CncTab = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const loadedRef = useRef(false);
    const [detail, setDetail] = useState(null);   // Go-live parity (2026-09-24): legacy click-through popups

    const fetchData = useCallback(async () => {
        try {
            // Go-live parity (2026-09-24): refresh in the background — the
            // spinner shows only on the first load, so the TV no longer blanks
            // every minute (rows stay until the new ones arrive).
            if (!loadedRef.current) setLoading(true);
            setError(null);
            const res = await api.get('/display-board/cnc');
            setData(res.data?.employees || []);
            loadedRef.current = true;
        } catch (err) {
            setError(err.response?.data?.error || err.message || 'Failed to load CNC data');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { fetchData(); }, [fetchData]);

    return (
        <Card className="border-0 shadow-sm">
            <CardHeader className="border-bottom d-flex justify-content-between align-items-center py-3">
                <h6 className="mb-0 fw-semibold">
                    <i className="ri-settings-3-line me-2 text-primary"></i>
                    CNC Department — Display Board
                </h6>
                <RefreshTimer onRefresh={fetchData} interval={60} />
            </CardHeader>
            <CardBody className="p-0">
                {error && (
                    <div className="alert alert-danger m-3 mb-0" role="alert">
                        <i className="ri-error-warning-line me-2"></i>{error}
                    </div>
                )}
                <DataTable
                    onRowClick={(row) => setDetail(historyDetail(row))}
                        highlightKey="JobNum"  // Round DB-1 — green = active job
                    columns={columns}
                    rows={data}
                    loading={loading}
                    emptyMessage="No CNC employees clocked in today"
                />
                <DetailModal request={detail} onClose={() => setDetail(null)} />
            </CardBody>
        </Card>
    );
};

export default CncTab;